import { apiClient } from './client';

export function listOrders (payload: { key: string; list: string[]; shop?: number | string }) {
  return apiClient.post('/orders/list', payload);
}

export function fetchOrder (orderId: number | string) {
  return apiClient.get('/orders/fetch', { params: { order_id: orderId } });
}

export function fetchWorkflowLogs (providerOrderId: string) {
  return apiClient.get('/orders/fetch-workflow-logs', { params: { providerOrderId } });
}

export function gdprRedactOrders (payload: { order_ids: (number | string)[]; shop?: number | string }) {
  return apiClient.post('/gdpr/redact-orders', payload);
}
